import { jsxs, jsx } from "react/jsx-runtime";
import { ThumbContainer, ThumbCircle } from "./styles.js";
import { Tooltip } from "./Tooltip.js";
import { getThumbPosition } from "./getThumbPosition.js";
function Thumb({
  min,
  max,
  value,
  isTooltipOpen,
  inputPosition,
  isInactive,
  isDisabled
}) {
  const thumbPosition = getThumbPosition(min, max, value);
  return /* @__PURE__ */ jsxs(ThumbContainer, {
    $isInactive: isInactive,
    $isDisabled: isDisabled,
    style: getThumbContainerStyle(thumbPosition),
    "data-testid": "ds-slider-thumb",
    children: [/* @__PURE__ */ jsx(ThumbCircle, {
      $isDisabled: isDisabled
    }), inputPosition === "none" && /* @__PURE__ */ jsx(Tooltip, {
      isOpen: isTooltipOpen,
      content: value,
      position: "top-center",
      children: (triggerProps) => /* @__PURE__ */ jsx("div", {
        ...triggerProps
      })
    })]
  });
}
function getThumbContainerStyle(thumbPosition) {
  return {
    left: thumbPosition,
    transform: `translateY(-50%) translateX(calc(${thumbPosition} * -1))`
  };
}
export {
  Thumb
};
//# sourceMappingURL=Thumb.js.map
